import layout4 from '@ameroservices-platform/attraction-flexposui/app/fuse-layouts/layout4/Layout4';

const FuseLayouts = {
	layout4,
};

export default FuseLayouts;
